import { Carousel, Image, Space } from "antd";
import { FC, useState } from "react";
import {
    LeftOutlined,
    RightOutlined,
    DownloadOutlined,
    SwapOutlined,
    RotateLeftOutlined,
    RotateRightOutlined,
    ZoomOutOutlined,
    ZoomInOutlined,
    UndoOutlined,
} from "@ant-design/icons";

interface PhotoCarouselProps {
    images: string[];
}

export const PhotoCarousel: FC<PhotoCarouselProps> = ({
    images
}) => {
    const [current, setCurrent] = useState(-1);
    return (
        <>
            <Carousel
                autoplay
                style={{
                    backgroundColor: '#133D5E80',
                    textAlign: 'center',
                    marginBottom: 24,
                }}
                arrows
                className="rounded-xl overflow-hidden"
            >
                {images.map((i, index) => {
                    return (
                        <div className="w-full aspect-video box-border text-center">
                            <img key={i} className="mx-auto h-full w-auto object-contain object-center cursor-zoom-in" src={i} onClick={() => setCurrent(index)} />
                        </div>
                    );
                })}
            </Carousel>
            <Image.PreviewGroup
                items={images}
                preview={{
                    current,
                    visible: current >= 0,
                    toolbarRender: (
                        _,
                        {
                            transform: { scale },
                            actions: {
                                onActive,
                                onFlipY,
                                onFlipX,
                                onRotateLeft,
                                onRotateRight,
                                onZoomOut,
                                onZoomIn,
                                onReset,
                            },
                        },
                    ) => (
                        <Space size={12} className="toolbar-wrapper">
                            <LeftOutlined onClick={() => onActive?.(-1)} />
                            <RightOutlined onClick={() => onActive?.(1)} />
                            {/*<DownloadOutlined onClick={onDownload} />*/}
                            <SwapOutlined rotate={90} onClick={onFlipY} />
                            <SwapOutlined onClick={onFlipX} />
                            <RotateLeftOutlined onClick={onRotateLeft} />
                            <RotateRightOutlined onClick={onRotateRight} />
                            <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
                            <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
                            <UndoOutlined onClick={onReset} />
                        </Space>
                    ),
                    onChange: (index) => {
                        setCurrent(index);
                    },
                    onVisibleChange: (visible, _prevVisible) => {
                        if (!visible) {
                            setCurrent(-1);
                        }
                    }
                }}
            />
        </>
    )
}